<template>
    <div class="perLibary">
        <div class="allBox app-body">
            <page-header
                @openLoginDiolog="goLogin"
                :state="isHaveLoginObj"
                @goExamintercept="judgeIslogin"
            ></page-header>
            <keep-alive>
                <scree-compent
                    @hook:mounted="onScreeComponet"
                    ref="scree"
                    :type="currentLibary"></scree-compent>
            </keep-alive>

            <div class="bottom">
                <div class="nav xy-between">
                    <div class="nav-tive jf">
                        <div class="topic xy-center">
                            <div class="yx-center avtie">
                                <div class="cursor">历年真题</div>
                                <div class="throw"></div>
                            </div>
                        </div>
                    </div>
                    <div class="search">
                        <el-input
                            placeholder="请输入关键字检索"
                            v-model="searchRealKey"
                        >
                            <template slot="append">
                                <i class="el-icon-search"></i>
                                <span class="cursor">搜索</span>
                            </template>
                        </el-input>
                    </div>
                </div>
                <!-- 列表 -->
                <div class="chapterList">
                    <div class="directory">
                        <div>
                            <div
                                class="chapterTree"
                                v-if="realTopic && realTopic.length !== 0"
                                v-loading="fristListLoading"
                            >
                                <div
                                    shadow="hover"
                                    class="listItem xy-between"
                                    v-for="(info, i) in realTopic"
                                    :key="i">
                                    <div class="left jf">
                                        <div class="order c-256CF4 font-size30">
                                            {{ i + 1 }}
                                        </div>
                                        <div class="throw"></div>
                                        <div class="info xy-center">
                                            <div>
                                                <div
                                                    class="
                                                        className
                                                        font-size18
                                                        c-333
                                                    "
                                                >
                                                    {{ info.chapter_name }}
                                                </div>
                                                <div
                                                    class="
                                                        decribtion
                                                        jf
                                                        font-size14
                                                    "
                                                >
                                                    <div>
                                                        题量：{{ info.question_count }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="right jf">
                                        <div
                                            class="
                                                btn
                                                makeTopic
                                                xy-center
                                                cursor
                                                font-size14
                                            "
                                            @click="makeMoreTopic(info)">
                                            开始做题
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="chapterTree" v-else>
                                <div class="emptyBox">
                                    <el-empty
                                        description="暂无数据~"
                                    ></el-empty>
                                </div>
                            </div>
                        </div>
                        <div class="paging xy-center">
                            <el-pagination
                                background
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="pageIndex"
                                :page-size="pageSsize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="num"
                            >
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 登录框 -->
        <login-diolog
            :show.sync="loginDiologShow"
            @changeLoginState="haveLogin"
        ></login-diolog>
        <!-- 登录框 -->
        <div class="selectType yx-center" @click="goPerTopicLibary">
            <img src="../../assets/img/tiku.png" alt="" />
            <div class="c-fff">机构题库</div>
        </div>
        <el-backtop :bottom="300">
            <div class="test xy-center">
                <i class="el-icon-arrow-up font-size50"></i>
            </div>
        </el-backtop>
        <bottom-ground></bottom-ground>
    </div>
</template>

<script>
import { GetQuestionInfo, GetPaperInfo } from "@/api/questionPaper";
import {
    GetColumnInfo,
    GetFirstSubChapterInfo,
    GetSubChapterInfo,
} from "@/api/category";
import { GetColumnPaper } from "@/api/exam";
import PageHeader from "@/components/header";
import ScreeCompent from "@/components/publicSort";
import PaperList from "@/components/perLibary/paperList";
import BottomGround from "@/components/bottomnav";
export default {
    name: "publicLibary",
    components: {
        PageHeader,
        ScreeCompent,
        BottomGround,
    },
    data() {
        return {
            currentLibary: "pub", // 类型为公共题库
            currentSatus: "",
            passClassId: "", // 子传父的id
            ColumnInfo: [],
            firstChapterList: [],
            realTopic: [],
            page: 1,
            page_size: 99999,
            fristListLoading: true,
            fristPages: 0,
            sortData: [],
            currentColumName: "",
            currentColumId: "",
            // 统计当前正确题数量
            currentTotal: {},
            pageIndex: 1,
            pageSsize: 10,
            num: 0,
            searchRealKey: "",
            timer: "",
            loginDiologShow: false,
            isHaveLoginObj: "",
        };
    },
    computed: {},
    watch: {
        passClassId(newVal) {
            this.page = 1;
            this.fristPages = 0;
            this.passClassId = newVal;
            this.GetColumnPaper(newVal, "");
        },
        searchRealKey(newVal) {
            clearTimeout(this.timer);
            this.realTopic = [];
            this.timer = setTimeout(() => {
                if (!newVal.trim()) {
                    this.GetColumnPaper(this.passClassId, "");
                } else {
                    this.GetColumnPaper(this.passClassId, newVal);
                }
            }, 500);
        },
    },
    created() {
        window.scroll(0, 0);
        // this.passClassId = this.$route.query.queryId
    },
    mounted() {},
    methods: {
        haveLogin(val) {
            this.isHaveLoginObj = val;
        },
        onScreeComponet () {
            // this.$refs.scree.fourClassIdActive = this.passClassId
            // this.$refs.scree.fristClassIdActive = "sdfasdfsad"
            // this.$refs.scree.threeClassIdActive = this.passClassId
        },
        goLogin() {
            this.loginDiologShow = true;
        },
        // 判断是否登录
        judgeIslogin() {
            let token = this.$store.state.user;
            if (!token || token === "null") {
                this.goLogin();
                return;
            }
        },
        handleSizeChange(newval) {
            this.pageSsize = newval;
            this.GetColumnPaper(this.passClassId);
        },
        handleCurrentChange(newval) {
            this.pageIndex = newval;
            this.GetColumnPaper(this.passClassId);
        },
        // 开始做卷
        makeMoreTopic(val) {
            let obj = {};
            obj.type = "practice";
            obj.info = val;
            obj.columName = val.sourceName;
            obj.allQuestions = 1;
            window.localStorage.setItem("TopicInfo", JSON.stringify(obj));
            this.$router.push("/publicMake");
        },
        async GetColumnPaper(id, val) {
            this.fristListLoading = true;
            this.firstChapterList = [];
            try {
                const { data } = await GetColumnPaper({
                    categoryId: id,
                    searchKey: val,
                    pageno: this.pageIndex,
                    pagesize: this.pageSsize,
                });
                this.num = data.count;
                this.fristListLoading = false;
                this.realTopic = data.data;
            } catch (error) {
                console.log(error);
            }
        },
        goPerTopicLibary() {
            if (this.$store.getters.isLogin) {
                this.$router.push("/question/organ");
            } else {
                this.goLogin()
            }
        },
    },
};
</script>

<style scoped lang="less">
.perLibary {
    width: 100%;
    height: 100%;

    .bottom {
        height: 100%;
        box-sizing: border-box;
        margin: 0 auto;

        .nav {
            width: 100%;
            height: 62px;
            background-color: white;
            padding: 0 30px;
            box-sizing: border-box;
            margin-bottom: 1px;
            margin-top: 20px;

            .tit {
                ::v-deep p {
                    font-size: 14px;
                }
            }

            .nav-tive {
                font-size: 16px;
                color: #72777f;

                .topic {
                    margin-right: 60px;
                }

                .paper {
                    height: 62px;
                    width: 100px;
                }

                .throw {
                    margin-top: 2px;
                    width: 20px;
                    height: 4px;
                    background: #256cf4;
                    border-radius: 2px;
                }

                .avtie {
                    color: #256cf4;
                    margin-top: 4px;
                }
            }

            ::v-deep .el-input {
                .el-input__inner {
                    border-color: #4a78d4;
                }

                .el-input-group__append {
                    background-color: #256cf4;
                    border: 2px solid #256cf4;
                    color: white;
                }
            }
        }

        .chapterList {
            display: flex;
            padding-bottom: 50px;
            box-sizing: border-box;

            .directory {
                width: 100%;

                .chapterTree {
                    min-height: 100px;
                    height: 600px;
                    height: 600px;
                    overflow: auto;

                    .son {
                        height: 70px;
                    }

                    .son:hover {
                        background-color: #f0f1f5;
                    }

                    .son:hover .makeTopic .btn .arrow {
                        background-color: #f0f1f5 !important;
                    }

                    .one {
                        .son {
                            padding-left: 10px;
                            border-bottom: 1px solid #e5e8ec;

                            .makeTopic {
                                .btn {
                                    width: 100%;
                                    height: 100%;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    cursor: pointer;

                                    .arrow {
                                        width: 100%;
                                        height: 100%;
                                        font-size: 30px;
                                        background-color: white;
                                        color: #256cf4;
                                    }

                                    .lock {
                                        width: 100%;
                                        height: 100%;
                                        border-radius: 4px;
                                        background: #256cf4;
                                        color: white;
                                        display: flex;
                                        justify-content: center;
                                        align-items: center;
                                    }
                                }
                            }
                        }

                        .el-icon-remove {
                            opacity: 0.8;
                        }

                        .name {
                            width: 500px;
                            margin-left: 10px;

                            .symbol {
                                border-radius: 50%;
                                width: 15px;
                                height: 15px;
                                background-color: #dee9fe;
                                color: #5b90f7;
                                margin-right: 5px;
                                flex-shrink: 0;
                            }
                        }

                        .topicNum {
                            width: 100px;
                            color: #858b94;
                        }

                        .makeTopic {
                            width: 96px;
                            height: 32px;
                            background: #256cf4;
                            border-radius: 4px;
                            color: white;
                            margin-left: 50px;
                        }

                        .twoParant {
                            background-color: #f7f8fc;
                        }

                        .two {
                            .son {
                                padding: 0 0 0 55px;
                                box-sizing: border-box;
                                border-bottom: 2px solid #e5e8ec;
                                position: relative;
                            }

                            .el-icon-remove {
                                opacity: 0.8;
                            }

                            .name {
                                width: 380px;
                                // margin-left: 10px;
                            }

                            .topicNum {
                                width: 50px;
                                color: #858b94;
                                margin-left: 40px;
                            }

                            .makeTopic {
                                width: 96px;
                                height: 32px;
                                background: #e9f0fd;
                                border-radius: 4px;
                                color: #256cf4;
                                position: absolute;
                                right: 0px;
                            }

                            .three {
                                .son {
                                    padding: 0 30px 0 60px;
                                    box-sizing: border-box;
                                }

                                .el-icon-remove {
                                    opacity: 0.8;
                                }

                                .name {
                                    width: 600px;
                                    margin-left: 10px;
                                }

                                .topicNum {
                                    width: 100px;
                                    color: #858b94;
                                }

                                .makeTopic {
                                    width: 96px;
                                    height: 32px;
                                    background: #e9f0fd;
                                    border-radius: 4px;
                                    color: #256cf4;
                                }
                            }
                        }
                    }

                    &::-webkit-scrollbar {
                        width: 6px;
                    }

                    &::-webkit-scrollbar-track {
                        border-radius: 6px;
                    }

                    &::-webkit-scrollbar-thumb {
                        border-radius: 6px;
                        background: #bac0ca;
                    }

                    .listItem {
                        width: 100%;
                        height: 124px;
                        background: #ffffff;
                        margin-top: 1px;
                        padding: 30px 40px;
                        box-sizing: border-box;

                        .left {
                            .throw {
                                width: 1px;
                                height: 50px;
                                background: #e5e8ec;
                                margin: 0 40px;
                            }
                        }

                        .info {
                            height: 65px;

                            .className {
                                // margin-bottom: 20px;
                            }
                            .decribtion {
                                margin-top: 20px;
                                .num {
                                    margin-left: 50px;
                                }
                            }
                            .topicType {
                                .left {
                                    margin-left: 60px;
                                }
                            }
                        }

                        .right {
                            .btn {
                                width: 98px;
                                height: 36px;
                                background: #ebf2ff;
                                border-radius: 18px;
                                color: white;
                            }

                            .collect {
                                color: #256cf4;
                                margin-right: 10px;
                            }

                            .makeTopic {
                                background: linear-gradient(
                                    270deg,
                                    #4987ff 0%,
                                    #4ca5fa 100%
                                );
                            }
                        }
                    }

                    .emptyBox {
                        width: 100%;
                        height: 100%;
                        background-color: #fff;
                    }
                }

                .paging {
                    margin-top: 20px;
                }
            }

            .makeTopicNum {
                // width: 30%;
                height: 320px;
                background-color: white;
                box-sizing: border-box;
                box-sizing: border-box;
                border-left: 1px solid #f1f2f6;

                .title {
                    height: 70px;
                    line-height: 70px;
                    padding-left: 20px;
                    border-bottom: 1px dashed #f1f2f6;

                    .subName {
                        word-wrap: break-word;
                        word-break: break-all;
                        word-wrap: break-word;
                    }
                }

                .total {
                    height: 150px;
                    padding: 0 20px;
                    border-bottom: 1px solid #f1f2f6;

                    .num {
                        width: 85px;
                        height: 100px;
                        background: #f3f5f9;
                        border-radius: 4px;
                        padding: 20px 0;
                        box-sizing: border-box;
                        font-size: 14px;

                        span {
                            font-size: 16px;
                            color: #ff4751;
                        }
                    }
                }

                .btn {
                    height: 100px;
                    line-height: 100px;
                    padding-left: 60px;

                    .test {
                        width: 120px;
                        height: 40px;
                        background: #f9f9fa;
                        border-radius: 8px 0px 0px 8px;
                        border: 1px solid #e5e8ec;
                    }
                }

                .errTopic {
                    width: 120px;
                    height: 40px;
                    background: #256cf4;
                    border-radius: 0px 8px 8px 0px;
                    color: white;
                }
            }
        }
    }

    .selectType {
        width: 80px;
        height: 88px;
        background: #256cf4;
        box-shadow: 0px 5px 15px 0px rgba(143, 146, 154, 0.2);
        border-radius: 8px;
        position: fixed;
        right: 40px;
        bottom: 365px;

        img {
            width: 35px;
            height: 40px;
        }
    }

    .el-backtop {
        width: unset;
        right: 40px !important;
        bottom: 300px !important;

        .test {
            width: 80px;
            height: 80px;
            background: #ffffff;
            box-shadow: 0px 5px 15px 0px rgba(143, 146, 154, 0.2);
            border-radius: 8px;
        }
    }
}
</style>
